// extracted by mini-css-extract-plugin
export default {"hover-only":"_3h3wA","hoverOnly":"_3h3wA","hover-only-and-collapsed":"_1aOlG","hoverOnlyAndCollapsed":"_1aOlG","hoverable":"PFD0m","permanent-icon":"_3IFbS","permanentIcon":"_3IFbS"};